import { describePlans, kindLabel } from './util';
import type { WarningListProps } from './types';

// Advisory list of names the model flagged as possible gibberish. Read-only.
export const WarningList = ({ warnings }: WarningListProps) => {
  if (warnings.length === 0) return null;
  return (
    <div className="syntax-warnings">
      <div className="syntax-warnings-title">Possibly unrecognized ({warnings.length})</div>
      {warnings.map((warning) => (
        <div key={warning.id} className="syntax-warning-row">
          <div className="syntax-row-main">
            <div className="syntax-warning-plans">{describePlans(warning.occurrences)}</div>
            <div className="syntax-warning-body">
              <div className="syntax-warning-name">{warning.name}</div>
              {warning.reason && <div className="syntax-reason">{warning.reason}</div>}
            </div>
          </div>
          <span className="syntax-kind">{kindLabel(warning.kind)}</span>
        </div>
      ))}
    </div>
  );
};
